const ENABLED = import.meta.env.VITE_PERF_LOG_UI === "true";

export function installScrollPerfProbe(label = "V3Tax") {
  if (!ENABLED || typeof window === "undefined") return () => {};

  let raf = 0;
  let last = performance.now();
  let worst = 0;

  const tick = () => {
    const now = performance.now();
    const delta = now - last;
    last = now;

    if (delta > worst) worst = delta;

    if (delta > 34) {
      console.warn(`[UI_PERF] ${label} frame drop`, {
        frameMs: Math.round(delta),
        worstMs: Math.round(worst),
        scrollY: Math.round(window.scrollY || 0),
        activeElement: document.activeElement?.tagName || null,
      });
    }

    raf = window.requestAnimationFrame(tick);
  };

  raf = window.requestAnimationFrame(tick);

  let observer = null;

  try {
    if ("PerformanceObserver" in window) {
      observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          console.warn(`[UI_PERF] ${label} long task`, {
            durationMs: Math.round(entry.duration),
            startMs: Math.round(entry.startTime),
          });
        }
      });

      observer.observe({ entryTypes: ["longtask"] });
    }
  } catch (_) {}

  return () => {
    if (raf) window.cancelAnimationFrame(raf);
    if (observer) observer.disconnect();
  };
}
